import { useApplicationPageLayoutMode } from "./ApplicationPageLayout";

export const getApplicationShellTerminology = (redesignedShell: boolean) => ({
  computePageTitle: redesignedShell ? "Compute" : "GPU Environments",
  computeBrowserTitle: redesignedShell
    ? "Compute | Brev"
    : "Environments | Brev",
  cloudComputeTab: redesignedShell ? "Cloud instances" : "Environments",
  localComputeTab: redesignedShell ? "Local device" : "Registered compute",
  createEnvironmentTitle: redesignedShell
    ? "Create cloud instance"
    : "Create Environment",
  createFirstEnvironmentTitle: redesignedShell
    ? "Create your first cloud instance"
    : "Create your first environment",
});

export const useApplicationShellTerminology = () =>
  getApplicationShellTerminology(useApplicationPageLayoutMode() === "fluid");
